import { render } from "./JoinType.vue?vue&type=template&id=02c884d3"
import script from "./JoinType.vue?vue&type=script&lang=js"
export * from "./JoinType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__